import React, { Component } from "react";
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import { testimonialImage } from 'assets/images/index'

class Testimonial extends Component{
    render(){
        return(
            <React.Fragment>
                <div className="row">
                    <div className="col-lg-12">
                        <Tabs>
                            <TabPanel>
                                <div className="rn-testimonial-content text-center">
                                    <div className="inner">
                                        <p>Game Changing for the African Entertainment Space.</p>
                                    </div>
                                    {/*<div className="author-info">*/}
                                    {/*    <h6><span>Aklima </span> - COO, AMERIMAR ENTERPRISES, INC.</h6>*/}
                                    {/*</div>*/}
                                </div>
                            </TabPanel>

                            <TabPanel>
                                <div className="rn-testimonial-content text-center">
                                    <div className="inner">
                                        <p>Something truly home grown for us and by us, love the content too.</p>
                                    </div>
                                    {/*<div className="author-info">*/}
                                    {/*    <h6><span>Fatima Asrafy </span> - COO, AMERIMAR ENTERPRISES, INC.</h6>*/}
                                    {/*</div>*/}
                                </div>
                            </TabPanel>
                            <TabPanel>
                                <div className="rn-testimonial-content text-center">
                                    <div className="inner">
                                        <p>Been waiting for something like this.</p>
                                    </div>
                                    {/*<div className="author-info">*/}
                                    {/*    <h6><span>Jannat Tumpa </span> - COO, AMERIMAR ENTERPRISES, INC.</h6>*/}
                                    {/*</div>*/}
                                </div>
                            </TabPanel>

                            <TabPanel>
                                <div className="rn-testimonial-content text-center">
                                    <div className="inner">
                                        <p>My kids love the kid offerings for african animations, so relatable for them.</p>
                                    </div>
                                    {/*<div className="author-info">*/}
                                    {/*    <h6><span>Johns Danga </span> - COO, AMERIMAR ENTERPRISES, INC.</h6>*/}
                                    {/*</div>*/}
                                </div>
                            </TabPanel>

                            <TabPanel>
                                <div className="rn-testimonial-content text-center">
                                    <div className="inner">
                                        <p>Chunk of original content.</p>
                                    </div>
                                    {/*<div className="author-info">*/}
                                    {/*    <h6><span>Amar Orthi </span> - COO, AMERIMAR ENTERPRISES, INC.</h6>*/}
                                    {/*</div>*/}
                                </div>
                            </TabPanel>
                            <TabPanel>
                                <div className="rn-testimonial-content text-center">
                                    <div className="inner">
                                        <p>You can't afford to miss, some of the eekly shows.</p>
                                    </div>
                                    {/*<div className="author-info">*/}
                                    {/*    <h6><span>Fatima Ma </span> - COO, AMERIMAR ENTERPRISES, INC.</h6>*/}
                                    {/*</div>*/}
                                </div>
                            </TabPanel>

                            <TabPanel>
                                <div className="rn-testimonial-content text-center">
                                    <div className="inner">
                                        <p>The next big thing in African Entertainment.</p>
                                    </div>
                                    {/*<div className="author-info">*/}
                                    {/*    <h6><span>JON CUMMINS </span> - COO, AMERIMAR ENTERPRISES, INC.</h6>*/}
                                    {/*</div>*/}
                                </div>
                            </TabPanel>

                            <TabList className="testimonial-thumb-wrapper">
                                <Tab>
                                    <div className="testimonial-thumbnai">
                                        <div className="thumb">
                                            <img src={testimonialImage} alt="Testimonial Images"/>
                                        </div>
                                    </div>
                                </Tab>
                                <Tab>
                                    <div className="testimonial-thumbnai">
                                        <div className="thumb">
                                            <img src={testimonialImage} alt="Testimonial Images"/>
                                        </div>
                                    </div>
                                </Tab>
                                <Tab>
                                    <div className="testimonial-thumbnai">
                                        <div className="thumb">
                                            <img src={testimonialImage} alt="Testimonial Images"/>
                                        </div>
                                    </div>
                                </Tab>
                                <Tab>
                                    <div className="testimonial-thumbnai">
                                        <div className="thumb">
                                            <img src={testimonialImage} alt="Testimonial Images"/>
                                        </div>
                                    </div>
                                </Tab>
                                <Tab>
                                    <div className="testimonial-thumbnai">
                                        <div className="thumb">
                                            <img src={testimonialImage} alt="Testimonial Images"/>
                                        </div>
                                    </div>
                                </Tab>
                                <Tab>
                                    <div className="testimonial-thumbnai">
                                        <div className="thumb">
                                            <img src={testimonialImage} alt="Testimonial Images"/>
                                        </div>
                                    </div>
                                </Tab>
                                <Tab>
                                    <div className="testimonial-thumbnai">
                                        <div className="thumb">
                                            <img src={testimonialImage} alt="Testimonial Images"/>
                                        </div>
                                    </div>
                                </Tab>
                            </TabList>
                        </Tabs>
                    </div>
                </div>
            </React.Fragment>
        )
    }
}
export default Testimonial;
